// src/components/dashboard/table-planner/SeatedGuest.jsx
import React from "react";

export default function SeatedGuest({ guest, onRemove }) {
  return (
    <div
      className={`p-2 bg-white rounded-md flex justify-between items-center border-l-4 ${
        guest.invitedBy === "groom"
          ? "border-blue-500"
          : guest.invitedBy === "bride"
          ? "border-pink-500"
          : "border-gray-300"
      }`}
    >
      <span className="text-sm">
        {guest.guestName} (Pax: {guest.pax})
      </span>
      <button
        onClick={onRemove}
        className="text-red-500 hover:text-red-700 font-bold"
      >
        &times;
      </button>
    </div>
  );
}
